import useOrganisationFeatures, {
  type OrganisationFeature,
} from 'app/hooks/useOrganisationFeatures';

/**
 * How a sidebar item's Plus feature shows. Once the new pricing launches, every Plus page is drawn
 * in Plus purple: `locked` when the plan doesn't include it (also tagged Plus+), `included` when it
 * does. Until the features load it is `pending`, so the item shows no tag rather than flicking from
 * one to another.
 */
export default function usePlusLock(
  feature: OrganisationFeature | undefined
): 'pending' | 'locked' | 'included' | 'open' {
  const { pricingLaunched, hasFeature, isLoading, isError } = useOrganisationFeatures();

  if (!feature) return 'open';
  if (isLoading || isError) return 'pending';
  if (!pricingLaunched) return 'open';

  return hasFeature(feature) ? 'included' : 'locked';
}
